export default __webpack_public_path__ + "static/media/plan1.ddcc303e.jpg";